module.exports = __webpack_public_path__ + "themes/mf/img/prize-7@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-7@2x.png
// module id = 99
// module chunks = 3